<template>
  <div @click.stop="()=>{}" class="page-title__content">
    <label v-if="error" class="page-title__error-message">This field can't be empty</label>
    <input class="page-title__label"
           :class="{ 'page-title__label-with-hover': !disabled }"
           ref="input"
           :type="type"
           @keypress.enter="pressEnter"
           @focusin="onFocus"
           @focusout="onBlur"
           v-model="slugName"
           :disabled="disabled" />
    <div v-if="showActionButtons" class="page-title__action-buttons">
      <div class="page-title__action-buttons__wrapper" style="margin-right: 2px;">
        <base-material-design-icon class="page-title__action-buttons__icon"
                                   :size="parseInt('24')"
                                   @click.stop="saveChanges"
                                   icon="check"/>
      </div>
      <div class="page-title__action-buttons__wrapper" style="margin-left: 2px;">
        <base-material-design-icon class="page-title__action-buttons__icon"
                                   :size="parseInt('24')"
                                   @click.stop="cancelChanges"
                                   icon="close"/>
      </div>
    </div>
    <slot class="page-title__slot"></slot>
  </div>
</template>

<script>
import validator from 'validator'
import BriefContent from '../features/content-briefs/brief-content/index'
/**
   * Is used on {@link BriefContent} only
   */
export default {
  name: 'BasePageTitle',
  props: {
    title: {
      type: String
    },
    /**
     * for PDf export
     */
    isStaticView: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: true
    },
    buttonTitle: {
      type: String,
      default: 'Back'
    },
    type: {
      type: String,
      default: 'text'
    }
  },
  data () {
    return {
      slugName: this.title,
      showActionButtons: false,
      error: false
    }
  },
  watch: {
    title (v) {
      this.slugName = v
    }
  },
  methods: {
    onFocus () {
      this.showActionButtons = true
    },
    onBlur () {
      if (this.showActionButtons) {
        window.addEventListener('mouseup', this.handler)
      }
    },
    handler () {
      setTimeout(() => {
        if (this.showActionButtons && !(validator.isEmpty(validator.ltrim(validator.rtrim(this.slugName))) && this.error)) {
          this.slugName = this.title
          this.showActionButtons = false
          this.error = false
        } else if (this.showActionButtons) {
          this.$refs.input.focus()
        }
        window.removeEventListener('mouseup', this.handler)
      }, 100)
    },
    pressEnter () {
      this.$refs.input.blur()
      this.saveChanges()
    },
    saveChanges () {
      if (this.slugName === this.title) {
        this.showActionButtons = false
        window.removeEventListener('mouseup', this.handler)
        return
      } else if (validator.isEmpty(validator.ltrim(validator.rtrim(this.slugName)))) {
        this.error = true
        this.$refs.input.focus()
        return
      }
      window.removeEventListener('mouseup', this.handler)
      this.error = false
      this.showActionButtons = false
      this.$emit('change-slug-name', this.slugName)
    },
    cancelChanges () {
      window.removeEventListener('mouseup', this.handler)
      this.error = false
      this.showActionButtons = false
      this.slugName = this.title
    }
  }
}
</script>

<style scoped lang="scss">
  .page-title {
    &__content {
      display: flex;
      align-items: center;
      justify-content: space-between;

      .button__wrapper {
      }
    }

    &__error-message {
      position: absolute;
      top: -15px;
      font-size: 12px;
      color: $rfx-light-red;
    }

    &__action-buttons {
      display: flex;
      position: absolute;
      right: 39px;
      z-index: 10;
      bottom: -73%;

      &__wrapper {
        background-color: $rfx-light-grey;
        border-radius: 3px;
        padding: 4px 4px 0;
        cursor: pointer;
      }

      &__icon {
        font-size: 24px;
        color: $rfx-light-blue;
      }
    }

    &__label-with-hover {
      &:hover {
        background-color: $rfx-light-grey !important;
      }
    }

    &__label {
      @include ellipsis;
      width: -webkit-fill-available;
      border: 2px solid transparent;
      border-radius: 3px;
      font-family: inherit;
      font-size: 20px;
      line-height: 24px;
      font-weight: 300;
      color: $rfx-dark-march;
      background-color: transparent;

      &:focus {
        outline: none;
        background-color: transparent !important;
        border: 2px solid $rfx-blue-medium;
      }
    }

    &__button {
      height: 50px;
      background-color: $rfx-medium-march;
      font-size: 12px;
      font-weight: 900;
      color: #fff;
      margin-right: 20px;
      font-style: normal;
      position: relative;
      border-radius: 4px;
      text-transform: uppercase;
      cursor: pointer;
      outline: none;
      padding: 0 20px 0 40px;
      border: none;

      &:before {
        position: absolute;
        display: block;
        top: 55px;
        content: '';
        left: 12px;
        width: 10px;
        height: 10px;
        border-left: 2px solid #fff;
        border-bottom: 2px solid #fff;
        transform: translate(6px, -37px) rotate(45deg);
      }
    }
  }
</style>
